module.exports={
  "Description": "KY : CCN-NNNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^KY[0-9]{5}$",
  "TestData": {
    "Valid": [
      "KY1-1234",
	  "KY12345"
    ],
    "Invalid": [
      "KY1234",
      "KY123456",
	  "K1-1234"
    ]
  }
}